import { Right } from "../classes/Right";

export class ImgLnkNavItem {
    path: string;
    children?: ImgLnkNavItemChild[];
    data: ImgLnkNavItemData
}

export class ImgLnkNavItemChild {
    path: string;
    data: ImgLnkNavItemData;
}
export class ImgLnkNavItemData {
    title: string;
    order?: number;
    requireUser: boolean;
    icon: string;
    right?: Right;
    hide?: boolean;
}

export const navItems: ImgLnkNavItem[] = [
    {
        path: 'config',
        data: {
            title: "configuration", icon: "fa-book", requireUser: true, right: Right.SSO
        },
    }
];
